const session = {};

export function getSession() {
  return session;
}
